import {
  Environment,
  SentryConfig
} from '@espoon-voltti/nuora-app-common/config'

const sentryConfig = (enabled: boolean): SentryConfig => ({
  dsn: 'https://2e1e19fcbedbd734881f361b947d67cc@o4507111645052928.ingest.de.sentry.io/4507417825706064',
  enabled
})

export interface AppConfig {
  sentry: SentryConfig
}

export const configs: Record<Environment, AppConfig> = {
  local: {
    sentry: sentryConfig(false)
  },
  dev: {
    sentry: sentryConfig(false)
  },
  test: {
    sentry: sentryConfig(false)
  },
  staging: {
    sentry: sentryConfig(true)
  },
  prod: {
    sentry: sentryConfig(true)
  }
}
